/* global location */
export default function getUrl(url) {
  const baseUrl = '/account/'
  url = url.startsWith('/') ? url.replace('/', '') : url

  return `${baseUrl}${url}`
}



// WEBPACK FOOTER //
// ./src/utils/url.js